<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card>
                    <Row align="middle">
                        <Col :xs="24" :md="{ span: 16, offset: 4 }">
                            <h1 class="text-center text-24 mb-3">{{ $t("views.accountLayout.title") }}</h1>
                        </Col>
                        <Col :xs="24">
                            <Tabs v-model:activeKey="state.tabKey" type="card">
                                <TabPane key="haz" :tab="$t('model.haz.info.searchHaz')" :forceRender="true">
                                    <Card :bordered="false" class="border-radius-0">
                                        <HazShortDetailList></HazShortDetailList>
                                    </Card>
                                </TabPane>
                                <!--TabPane key="license" :tab="$t('model.hazLicense.info.searchHazLicenseS3O4')" :forceRender="false">
                                    <Card :bordered="false" class="border-radius-0">
                                        <HazLicenseShortDetailList type="4"></HazLicenseShortDetailList>
                                    </Card>
                                </TabPane-->
                                <TabPane key="xxx" :tab="$t('model.hazLicense.info.searchHazLicenseS3O5')" :forceRender="false">
                                    <Card :bordered="false" class="border-radius-0">
                                        <HazLicenseShortDetailList type="5"></HazLicenseShortDetailList>
                                    </Card>
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { Card, Col, Layout, Row, Tabs } from "ant-design-vue";
import { defineAsyncComponent, defineComponent } from "vue";
import { state as stateApp } from "../../../app.logic";
import { initState, isLoading, onSearch, state } from "./short-detail.logic";

export default defineComponent({
    components: {
        Tabs,
        TabPane: Tabs.TabPane,
        Layout,
        Row,
        Col,
        Card,
        HazShortDetailList: defineAsyncComponent(() => import("./haz-short-detail/HazShortDetailList.vue")),
        HazLicenseShortDetailList: defineAsyncComponent(() => import("./haz-license-short-detail/HazLicenseShortDetailList.vue")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "" }
    },
    setup(props) {
        initState({ props });
        return { props, isLoading, state, onSearch };
    }
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
</style>